import { FC } from 'react';
import {
  Datagrid,
  EditButton,
  List,
  TextField,
  BooleanField,
} from 'react-admin';

export const InsalesList: FC = () => (
  <List title="Insales интеграции" filter={{}}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" label="Имя" />
      <TextField source="url" label="URL" />
      <TextField source="user" label="API пользователь" />
      <TextField source="site_url" label="Url сайта" />
      <BooleanField source="is_enabled" label="Статус" />
      <EditButton />
    </Datagrid>
  </List>
);
